import { formatService } from '../common/format.service'
import { Legend, SHAPE } from '../common/legend/legend'

import { useStyles } from './control-bar.style'

export const ControlBar = function ({ stateLabels, totalSize, valueLabel, stateColors, customTotal }) {
  const classes = useStyles()

  return (
    <Legend labels={stateLabels} colors={stateColors} shape={SHAPE.RECT} enableBorder={true} className={classes.legend}>
      {customTotal || `Total: ${formatService.formatNumberRoundedToInteger(totalSize)} ${valueLabel}`}
    </Legend>
  )
}
